import React from "react"
import themeConfig from "../configs/themeConfig"
import classnames from "classnames"
import { Button, UncontrolledTooltip } from 'reactstrap'
import { ArrowLeft } from 'react-feather'

// images
import featureCircle from './../assets/img/login/feature-circle.png'
import featureCircleTwo from './../assets/img/login/feature-circle-two.png'
import mainBanner from './../assets/img/login/main-banner1.png'

const FullPageLayout = ({ children, ...rest }) => {

  const redirectHomePage = () => {
    window.location.href = "https://www.growthsayer.com"
  }


  return (
    <div
      className={classnames(
        "full-layout wrapper bg-full-screen-image blank-page dark-layout",
        {
          "layout-dark": themeConfig.layoutDark
        }
      )}
    >
      <div className="decor">
        <div className="screenshot-circle1">
          <img src={featureCircleTwo} alt="feature-circle-two" />
        </div>
        <div className="screenshot-circle2">
          <img src={featureCircle} alt="feature-circle" />
        </div>
        <div className="screenshot-circle3">
          <img src={mainBanner} alt="feature-circle-three" />
        </div>
      </div>
      <div className="app-content p-2">
        <div className="mt-1">
          {/* <UncontrolledTooltip placement="top" target="goBackHomePage">Go Back to Home Page</UncontrolledTooltip> */}
          <Button size="sm" onClick={redirectHomePage} outline type="button" classname={'btn btn-lg'} id="goBackHomePage" color="info" >
            <ArrowLeft size="15" /> &nbsp; GrowthSayer Home
          </Button>
        </div>
        <div className="content-wrapper">
          <div className="content-body">
            <div className="flexbox-container">
              <main className="main w-100">{children}</main>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FullPageLayout
